module.exports = __webpack_public_path__ + "img/3.72ee1b43.png";